import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./components/Home";   
import Apropos from "./components/Apropos";
import Galerie from "./components/Galerie";
import Contact from "./components/Contact";

const DefaultLayout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Public pages */}
        <Route path="/" element={<DefaultLayout><Home /></DefaultLayout>} />
        <Route path="/about" element={<DefaultLayout><Apropos /></DefaultLayout>} />
        <Route path="/gallery" element={<DefaultLayout><Galerie /></DefaultLayout>} />
        <Route path="/contact" element={<DefaultLayout><Contact /></DefaultLayout>} />
      </Routes>
    </Router>
  );
};

export default App;
